import apiClient from '@/utils/apiClient';
import axios from 'axios';

const calComApiClient = axios.create({
	baseURL: import.meta.env.VITE_APP_CAL_COM_API_URL,
	timeout: 10000,
});

const CAL_COM_API_ENDPOINTS = {
	getAllUsersEventTypesPath: () => '/event-types',
	getAllApiKeysPath: () => '/calcom',
};

const CAL_COM_SERVER_API_ENDPOINTS = {
	getAllApiKeysPath: (username: string | undefined) =>
		`/api/calendars/cal-com/api-keys/${username}`,
	addCalComCalendarPath: () => '/api/calendars/cal-com/',
};

export const getAllUserEventTypes = async ({ apiKey }: { apiKey: string }) => {
	const response = await calComApiClient.get(CAL_COM_API_ENDPOINTS.getAllUsersEventTypesPath(), {
		params: {
			apiKey,
		},
	});
	return response.data?.event_types || [];
};

export const getAllCalComApiKeys = async (username: string | undefined) => {
	const response = await apiClient.request({
		method: 'GET',
		endPoint: CAL_COM_SERVER_API_ENDPOINTS.getAllApiKeysPath(username),
	});
	return response.data || [];
};

export const addCalComCalendar = async (data: any) => {
	const response = await apiClient.request({
		method: 'POST',
		endPoint: CAL_COM_SERVER_API_ENDPOINTS.addCalComCalendarPath(),
		body: data,
	});
	return response.data || [];
};
